import { render, staticRenderFns } from "./LegacyDealImportModal.vue?vue&type=template&id=3fc1f2b3"
import script from "./LegacyDealImportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegacyDealImportModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc1f2b3')) {
      api.createRecord('3fc1f2b3', component.options)
    } else {
      api.reload('3fc1f2b3', component.options)
    }
    module.hot.accept("./LegacyDealImportModal.vue?vue&type=template&id=3fc1f2b3", function () {
      api.rerender('3fc1f2b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/LegacyDealImportModal.vue"
export default component.exports